import cx from 'classnames';
import React from 'react';

export const Switch = ({
  onClick,
  checked,
}: {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  checked: boolean;
}) => {
  return (
    <button
      type="button"
      onClick={e => {
        onClick?.(e);
      }}
      className={cx(
        'relative inline-flex h-4 w-8 shrink-0 items-center rounded-full cursor-pointer',
        'outline-none ui-focus-visible:ring-2 ui-focus-visible:ring-blue-500 ui-focus-visible:ring-offset-2 ui-focus-visible:ring-offset-spring-neutral-base',
        {
          'bg-blue-500': checked,
          'bg-gray-600': !checked,
        },
      )}
      aria-pressed={checked}
      data-testid="switch-button"
    >
      <span
        className={`inline-block h-3 w-3 transform rounded-full bg-white transition ${
          checked ? 'translate-x-[1.125rem]' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
};
